import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { Exercise } from '../types'
import {
  FetchExercisesAction,
  FETCH_EXERCISES,
  FETCH_EXERCISES_FAIL,
  FETCH_EXERCISES_SUCCESS
} from '../redux/exercisesReducer'

function* FetchExercisesFlow(action: FetchExercisesAction): Generator<any, void, any> {
  try {
    const response: Exercise[] = yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/${action.payload.lessonPlanId}/exercises`,
      method: 'GET',
      params: {}
    })
    yield put(FETCH_EXERCISES_SUCCESS({ lessonPlanId: action.payload.lessonPlanId, exercises: response }))
  } catch (error) {
    yield put(FETCH_EXERCISES_FAIL())
    console.log(error)
  }
}

export default function* FetchExercisesSaga(): Generator<any, void, any> {
  yield takeLatest([FETCH_EXERCISES], FetchExercisesFlow)
}
